window.addEventListener("load", function () {
  function isExternalLink(url) {
    try {
      const linkUrl = new URL(url, window.location.href);
      return linkUrl.host !== window.location.host;
    } catch (e) {
      console.error("Invalid URL:", url);
      return false;
    }
  }

  function isFileLink(url) {
    const fileExtensions = [
      ".pdf",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".ppt",
      ".pptx",
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".zip",
      ".rar",
    ];
    return fileExtensions.some((ext) => url.toLowerCase().includes(ext));
  }

  const links = document.querySelectorAll("a");

  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (!href) return;

    const shouldOpenInNewTab = isExternalLink(href) || isFileLink(href);
    if (shouldOpenInNewTab) {
      link.target = "_blank";
      link.rel = "noopener noreferrer";
    }
  });
});
